<div *transloco="let t" class="open-sans text-white bg-[#F28F17]">
    <div class="rounded-b-[50px] bg-calm">
        <div class="pb-10 px-2.5 md:px-10 lg:max-w-[1080px] mx-auto"><app-header></app-header>
            <div class="flex gap-[5%]">
                <div class="w-[70%] text-[#F28F17]">
                    <h1 class="text-[50px] pt-10 pb-5">{{t('createYourQuiz')}} <span class="font-bold">quizshow!</span>
                    </h1>
                    <div class="text-[20px] font-semibold">{{t('quizDesc')}}</div>
                    <div class="text-[20px] mt-2.5 font-semibold">{{t('quizDesc2')}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="text-[#182A43] px-2.5 md:px-10 font-bold text-[18px] lg:max-w-[1080px] mx-auto pt-10 pb-10">
        <div class="items-center gap-2.5 flex"><img class="h-[40px]" src="assets/check.svg" alt="Check"> {{t('miniDesc1')}}</div>
        <div class="items-center gap-2.5 mt-2.5 flex"><img class="h-[40px]" src="assets/check.svg" alt="Check"> {{t('miniDesc2')}}</div>
        <div class="items-center gap-2.5 mt-2.5 flex"><img class="h-[40px]" src="assets/check.svg" alt="Check"> {{t('miniDesc3')}}</div>
    </div>
    <div class="bg-calm pb-[160px] rounded-t-[50px] uppercase">
        <div class="px-2.5 md:px-10 lg:max-w-[1080px] mx-auto pt-10">
            <div class="font-bold text-[20px]">{{t('alreadyUsedBy')}}</div>
            <div class="flex gap-10 gap-y-10 flex-wrap mt-10 items-center">
                @for (logo of logos; track $index) {
                <div class="size-[100px] content-center"><img class="w-full" [src]="logo">
                    </div><!-- <div class="bg-white flex items-center place-content-center text-[28px] font-bold size-[100px] rounded-full text-[#F28F17] p-2.5 ">Logo</div> -->
                }
            </div>
        </div>
    </div>
</div>